
import { deleteRequest, getRequest, postRequest, putRequest } from '../../services/httpService';

// Enums for embryo grading fields
export enum GradeEnum {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
}

export enum IcmTeGradeEnum {
  A = 'A',
  B = 'B',
  C = 'C',
}

export interface Patient {
  id: number;
  name: string;
  first_name: string;
  last_name: string;
  mrn: string;
  age: number;
  sex: string;
  cultureDay?: string | null;
  avatarUrl?: string | null;
  selected: boolean;
  gender: string;
  allergy: string | null;
  date?: string | null;
  lastModified?: string;
  cycle_id: number | null;
  cycle_name: string | null;
  day?: number | null;
  partnerName?: string;
  patient_history_id?: number | null;
  is_result_available?: boolean | false;
}

export interface Embryo {
  id: number;
  embryoNumber: string;
  grade: number;
  avatarUrl: string;
  selected: boolean;
  cycle_id: number;
}

export interface EmbryoEditValues {
  aiViabilityScore: number;
  grade: string;
  icmGrade: string;
  teGrade: string;
  embryoId : string;
}


export interface EditHistoryValues {
  name: string;
}



// Embryo Results Details Interface
export interface EmbryoResultsDetails {
  EmbryoInformationDetails: {
    aiViabilityScore: number;
    grade: string;
    icmGrade: string;
    teGrade: string;
    embryoId : string;
  };
  icm_seg_path: string;
  te_cell_segms_img_path: string;
  grade_features: Array<{
    name: string;
    value: number;
  }>;
  icm_features: Array<{
    name: string;
    value: number;
  }>;
  te_features: Array<{
    name: string;
    value: number;
  }>;
  development_annotations1: Array<{
    name: string;
    value: number;
  }>;
  development_annotations2: Array<{
    name: string;
    value: number;
  }>;
  development_annotations3: Array<{
    name: string;
    value: number;
  }>;
}

//--------------------------------------------------
export interface Result {
  id: number;
  retrievedAt: string;
  index: number;
  cycle_id: number;
  is_result_available: boolean;
  isSelected: boolean;
  session_id : number | null;
  patient_id : number | null;
}


export interface RedirectSessionDetails {
  session_id : number | null;
  patient_id : number | null;
}


interface CreateGradingHistoryPayload {
  patients: {
    patient_id: number;
    cycle_id: number | null;
  }[];
}

interface getEmbryoPatientsParams {
  ClinicId: string;
  name_search : string;
}


interface getEmbryoListForSelectedPatientsParams {
  cycle_id: number | null;
}


interface getEmbryoResultsParams {
  cycle_id: number | null;
  embryo_id: number | null;
}


interface getPatientHistoryDetailAndCheckResultIsAvailableParams {
  history_id: number | null;
}

interface getGradingHistoryParams {
  name: string;
}

interface getSelectedGradingHistoryParams {
  HistoryId: number | null;
}


export interface UpdateEmbryoGradePayload {
  embryo_id: string;
  grade_label: string;
  icm_label: string;
  te_label: string;
}

export interface GradingHistoryItem {

  id: number;
  name: string;
  trigger_source?: string;
  triggered_by_name?: string;
  isSelected: boolean;
}

export interface EmbroCheckData {
  patient_id: string,
  cycle_id: number,
  has_day5_embryos: boolean
}

//get only day 5 available patients
export function getEmbryoPatients({
  ClinicId = '',
  name_search = ''
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getEmbryoPatientsParams): Promise<any> {
  const url = `/cycle/embryology/?limit=10&offset=0&order_by=created_on&patient__patient_type__icontains=patient&day=5&clinic=${ClinicId}&name_search=${name_search}`;
  return getRequest(url, { responseType: 'json' });
}


export function createGradingHistory(data: CreateGradingHistoryPayload): Promise<CreateGradingHistoryPayload> {
  const url = 'grading-history/create-history/';  
  return postRequest(url, data, { responseType: 'json' });
}



export function getGradingHistory({
  name = '',
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getGradingHistoryParams): Promise<any> {
  const url = `/grading-history/?name=${name}`;
  return getRequest(url, { responseType: 'json' });
}



export function getEmbryoListForSelectedPatients({
  cycle_id = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getEmbryoListForSelectedPatientsParams): Promise<any> {
  const url = `/embryo/embryo-results/?cycle_id=${cycle_id}`;
  return getRequest(url, { responseType: 'json' });
}


export function getEmbryoResultForSelectedEmbryo({
  cycle_id = null,
  embryo_id = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getEmbryoResultsParams): Promise<any> {
  const url = `/embryo/embryo-results/?cycle_id=${cycle_id}&embryo_id=${embryo_id}`;
  return getRequest(url, { responseType: 'json' });
}





export function getPatientHistoryDetailAndCheckResultIsAvailable({
  history_id = null,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getPatientHistoryDetailAndCheckResultIsAvailableParams): Promise<any> {
  const url = `/grading-history/history-detail/?history_id=${history_id}`;
  return getRequest(url, { responseType: 'json' });
}



export function deleteGradingHistory({
  HistoryId = null,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getSelectedGradingHistoryParams): Promise<any> {
  const url = `/grading-history/${HistoryId}`;
  return deleteRequest(url, { responseType: 'json' });
}



export function getSelectedGradingHistory({
  HistoryId = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getSelectedGradingHistoryParams): Promise<any> {
  const url = `/grading-history/${HistoryId}`;
  return getRequest(url, { responseType: 'json' });
}



export function updateSelectedGradingHistory(HistoryId: string, payload: EditHistoryValues): Promise<EditHistoryValues> {
  const url = `/grading-history/${HistoryId}`;
  return putRequest(url, payload);
}



// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateEmbryoGrade(HistoryId: string, payload: UpdateEmbryoGradePayload): Promise<any> {
  const url = `/grading-history/update-embryo-grade/?history_id=${HistoryId}`;
  return putRequest(url, payload);
}


interface getPatientHistoryListParams {
  patient_id: number | null;
}

export function getPatientHistoryResultList({
  patient_id = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: getPatientHistoryListParams): Promise<any> {
  const url = `grading-history/patient-history-list/?patient_id=${patient_id}`;
  return getRequest(url, { responseType: 'json' });
}

export function getcheckEmbryosURL(id: number): string {
  return `cycle/check-embryos/?patient_id=${id}`;
}

export function checkEmbryos(id: number): Promise<EmbroCheckData> {
  return getRequest(getcheckEmbryosURL(id), { responseType: 'json' });
}


interface embryoGradingResultsDetailsSinglePatientParams {
  history_id: number | null;
}


export function embryoGradingResultsDetailsSinglePatient({
  history_id = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: embryoGradingResultsDetailsSinglePatientParams): Promise<any> {
  const url = `grading-history/embryo-grading-results/?history_id=${history_id}`;
  return getRequest(url, { responseType: 'json' });
}



//-----------------------------


// helper to fetch Embryo Result and handle state and alert
export async function fetchEmbryoResult(
  data: Embryo,
  setSelectedEmbryoResult: (result: EmbryoResultsDetails | null) => void,
  addAlert: (msg: string, severity: 'success' | 'info' | 'warning' | 'error') => void,
  tAiGrading: (key: string, options?: { defaultValue: string }) => string
) {
  try {
    const response = await getEmbryoResultForSelectedEmbryo({ cycle_id: data.cycle_id, embryo_id: data.id });
    if (response) {
      const embryo = response;
      const embryoResult: EmbryoResultsDetails = {
        EmbryoInformationDetails: {
          aiViabilityScore: embryo.final_grade,
          grade: embryo.grade_label,
          icmGrade: embryo.icm_label,
          teGrade: embryo.te_label,
          embryoId: embryo.embryo_id
        },
        icm_seg_path: embryo.icm_seg_path,
        te_cell_segms_img_path: embryo.te_cell_segms_img_path,
        grade_features: embryo.grade_features || [],
        icm_features: embryo.icm_features || [],
        te_features: embryo.te_features || [],
        development_annotations1: embryo.development_annotations[0] || [],
        development_annotations2: embryo.development_annotations[1] || [],
        development_annotations3: embryo.development_annotations[2] || []
      };
      setSelectedEmbryoResult(embryoResult);
    } else {
      setSelectedEmbryoResult(null);
    }
  } catch {
    addAlert(tAiGrading('FailedToFetchEmbryoResult', { defaultValue: 'Failed to fetch embryo result' }), 'error');
  }
}




// fetch Embryo list as per Patient and set state, then fetch result for first embryo
export async function fetchEmbryoList(
  patient: Patient,
  setSelectedEmbryosGrading: (embryos: Embryo[]) => void,
  setSelectedEmbryoResult: (result: EmbryoResultsDetails | null) => void,
  addAlert: (msg: string, severity: 'success' | 'info' | 'warning' | 'error') => void,
  fetchEmbryoResult: (embryo: Embryo, setSelectedEmbryoResult: (result: EmbryoResultsDetails | null) => void, addAlert: (msg: string, severity: 'success' | 'info' | 'warning' | 'error') => void ,  tAiGrading: (key: string, options?: { defaultValue: string }) => string) => void,
  setSelectedEmbryoForGrading: React.Dispatch<React.SetStateAction<Embryo | null>>,
  tAiGrading: (key: string, options?: { defaultValue: string }) => string
) {
  try {
    const response = await getEmbryoListForSelectedPatients({ cycle_id: patient.cycle_id });
    if (response && Array.isArray(response.embryos)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const mappedEmbryos = response.embryos.map((embryo: any, idx: number) => ({
        id: embryo.id,
        selected: idx === 0,
        embryoNumber: embryo.embryo_num,
        grade: embryo.final_grade,
        avatarUrl: embryo.image_url,
        cycle_id: response.cycle_id
      }));
      setSelectedEmbryosGrading(mappedEmbryos);
      if (mappedEmbryos[0]?.cycle_id && mappedEmbryos[0]?.id) {
        setSelectedEmbryoForGrading(mappedEmbryos[0]); // set first embryo as selected
        fetchEmbryoResult(mappedEmbryos[0], setSelectedEmbryoResult, addAlert , tAiGrading); // fetch result for first embryo
      }
    }
  } catch {
    addAlert(tAiGrading('FailedToFetchEmbryoList'), 'error');
  }
}


//bul patient new grading helper
export const handleNewAIGradingHelper = (
  toggleEmbryoGradingDetailsOpen: (open: boolean) => void,
  setSelectedPatientsForEmbryoGrading: React.Dispatch<React.SetStateAction<Patient[]>>,
  setSelectedGradingHistory: React.Dispatch<React.SetStateAction<GradingHistoryItem | null>>,
  setGradingHistoriesList: React.Dispatch<React.SetStateAction<GradingHistoryItem[]>>
) => {
  toggleEmbryoGradingDetailsOpen(false); // close details and show embryo grading Assistance
  setSelectedPatientsForEmbryoGrading([]); // Clear selected patients when starting new grading

  setSelectedGradingHistory(null); // Reset selected grading history
  setGradingHistoriesList((prev) => prev.map(item => ({ ...item, isSelected: false }))); // Unselect all items
};







// Helper to map patient and result data from getPatientHistoryResultList response (for reuse in DayFour and single patient grading modal)
export function mapPatientHistoryResults(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: any[],
  setSelectedPatientForGrading: (patient: Patient) => void,
  setResultListForSelectedPatient: (results: Result[]) => void,
  setSelectedResultFromResultList: (result: Result | null) => void,
) {
  const mappedResults = response.map((result: unknown, idx: number) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Result = result as any;

    // Set patient details from first result
    if (idx === 0) {
      const mappedPatientDetails = Result.patient;
      const patientDetails: Patient = {
        id: mappedPatientDetails.id,
        name: [mappedPatientDetails.first_name, mappedPatientDetails.last_name].filter(Boolean).join(' '),
        mrn: mappedPatientDetails.medical_record_no,
        first_name: mappedPatientDetails.first_name,
        last_name: mappedPatientDetails.last_name,
        age: mappedPatientDetails.age,
        sex: mappedPatientDetails.gender__name,
        avatarUrl: mappedPatientDetails.photo,
        selected: true,
        gender: mappedPatientDetails.gender__name,
        allergy: null,
        lastModified: mappedPatientDetails.created_on,
        cycle_name: Result.cycle_number || null,
        cycle_id: Result.cycle || null,
        patient_history_id: Result.id,
        is_result_available: Result.is_result_available || false
      };
      setSelectedPatientForGrading(patientDetails);
    }

    return {
      id: Result.id,
      retrievedAt: Result.retrieved_at,
      index: response.length - idx, // Reverse index for display
      cycle_id: Result.cycle,
      is_result_available: Result.is_result_available,
      isSelected: idx === 0,
      session_id : Result.session_id || null,
      patient_id : Result.patient ? Result.patient.id : null
    };
  });
  setResultListForSelectedPatient(mappedResults);
  setSelectedResultFromResultList(mappedResults.length > 0 ? mappedResults[0] : null);
  
}